import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import { firebaseConfig } from '../appConstants';

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseStorage = firebase.storage();
export const firestore = firebase.firestore;
